var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",style:({ background: _vm.color }),on:{"click":function($event){return _vm.onClick()}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }